import { render, staticRenderFns } from "./EditBrandModal.vue?vue&type=template&id=1e0b0a84&scoped=true"
import script from "./EditBrandModal.vue?vue&type=script&lang=js"
export * from "./EditBrandModal.vue?vue&type=script&lang=js"
import style0 from "./EditBrandModal.vue?vue&type=style&index=0&id=1e0b0a84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0b0a84",
  null
  
)

export default component.exports